/**
 * Hook to listen for skill XP gain events via WebSocket
 * Automatically triggers the XP gain toast notification when XP is gained
 * Uses batching to combine multiple rapid XP events into a single notification
 */

import { useBatchedWebSocketEvent } from './useWebSocketEvent'
import { useToast } from '../contexts/ToastContext'

export function useSkillXPGain(isAuthenticated = false) {
  const toast = useToast()

  useBatchedWebSocketEvent(
    'player.skill.experience_gained',
    // Process batched events
    (events) => {
      if (events.length === 1) {
        // Single event - show as normal
        const event = events[0]
        toast.xpGain(event.xp_amount, event.skill_name)
      } else {
        // Multiple events - show combined notification
        const totalXp = events.reduce((sum, e) => sum + e.xp_amount, 0)
        const skillCount = events.length
        toast.xpGainBatch(totalXp, skillCount)
        console.log(`⭐ Batched ${skillCount} XP events: ${totalXp} total XP`)
      }
    },
    // Validate each event
    (event) => {
      if (!event.xp_amount || !event.skill_name) {
        console.warn('Skill XP gain event missing required fields:', event)
        return false
      }
      console.log('⭐ Skill XP gain event received:', event)
      return true
    },
    isAuthenticated,
    500, // Batch window in ms
    [toast]
  )
}

export default useSkillXPGain
